import { Content, Portal, Root, Trigger } from '@radix-ui/react-dropdown-menu';
import cl from 'clsx';

import CheckIcon from '@synapex/frontend-shared/icons/check-15x12.svg?react';
import ChevronDown from '@synapex/frontend-shared/icons/chevron-down-24.svg?react';

import { preventDefault } from '@/true-fsd/shared/utils/react';

import classes from './GmtSelect.module.scss';
import dropdownMenuClasses from './DropdownMenu.module.scss';
import { OPTIONS, GmtValue } from './lib';

//they are ordered like written, it is guaranteed by Ecma standards
const OPTIONS_ENTRIES = Object.entries(OPTIONS) as Array<[GmtValue, string]>;

type GmtItemProps = {
  value: GmtValue;
  label: string;
  selected: boolean;
  onSelect: (v: GmtValue) => void;
};
const GmtItem = ({ value, label, selected, onSelect }: GmtItemProps) => {
  const onClick = () => onSelect(value);

  return (
    <div
      className={cl(classes.itemOrTrigger, classes.item, {
        [classes.selected]: selected,
      })}
      onClick={onClick}
    >
      {label}
      <CheckIcon className={classes.check} />
    </div>
  );
};

export type GmtSelectProps = {
  className?: string;
  value: GmtValue;
  onChange: (v: GmtValue) => void;
};
export const GmtSelect = (allProps: GmtSelectProps) => {
  const { onChange, className, ...props } = allProps;
  return (
    <Root modal>
      <Trigger
        className={cl(classes.itemOrTrigger, classes.trigger, className)}
      >
        {OPTIONS[props.value]}
        <ChevronDown className={classes.chevron} />
      </Trigger>
      <Portal>
        <Content
          onCloseAutoFocus={preventDefault}
          side={'bottom'}
          align="start"
          className={cl(dropdownMenuClasses.content, classes.content)}
        >
          {OPTIONS_ENTRIES.map(([value, label]) => (
            <GmtItem
              value={value}
              label={label}
              selected={value === props.value}
              onSelect={onChange}
            />
          ))}
        </Content>
      </Portal>
    </Root>
  );
};
